import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { ITemplateVariationsPayload } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useCreateTemplateVariations = () => {
  return useMutation({
    mutationFn: createTemplateVariations,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries(queryKeys.products.invalidateAll()),
        queryClient.invalidateQueries(
          queryKeys.productVariations.invalidateAll(),
        ),
      ]);
    },
  });
};

const createTemplateVariations = async (
  payload: ITemplateVariationsPayload,
) => {
  const response = await requestCCApi({
    url: `/bulkVariationTemplatesUpdate`,
    method: 'PUT',
    data: { data: payload },
  });

  return response;
};
